import { User } from '@amzn/coral_com-amazon-passportusermanagementservice';

export const SLICE = 'ui';

export const PUSH_ROUTE = `${SLICE}/PUSH_ROUTE`;

export const ADD_NOTIFICATION = `${SLICE}/ADD_NOTIFICATION`;
export const CLOSE_NOTIFICATION = `${SLICE}/CLOSE_NOTIFICATION`;

export const START_REQUEST_LOADING = `${SLICE}/START_REQUEST_LOADING`;
export const END_REQUEST_LOADING = `${SLICE}/END_REQUEST_LOADING`;

export const NotificationTypeEnum = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
});

export const DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
export const DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;
export interface Notification {
  id: string;
  type: string;
  title: string;
  timeout: number;
}

export interface UIReducerProps {
  notifications: Notification[];
  pendingRequests: Array<string>;
  deactivateUserModal: {
    isOpen: boolean;
    userToDeactivate: User;
  };
}

export interface UIReducerStateProps {
  [id: string]: UIReducerProps;
}

export const OPEN_DEACTIVATE_USERS_MODAL = `${SLICE}/OPEN_DEACTIVATE_USERS_MODAL`;
export const CLOSE_DEACTIVATE_USERS_MODAL = `${SLICE}/CLOSE_DEACTIVATE_USERS_MODAL`;
